import { Body, Controller, Post, UploadedFile, UseInterceptors } from "@nestjs/common";
import { ApiBody, ApiConsumes, ApiTags } from "@nestjs/swagger";
import { VehicleService } from "./vehicle.service";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel, PlantIdReq, VehicleTypeReq } from "@project-management-system/shared-models";
import { VehicleDto } from "./vehicle.dto";
import { FileInterceptor } from "@nestjs/platform-express";
import { join } from "path";
import {diskStorage} from 'multer';
import { UploadResponse } from 'packages/libs/shared-models/src/common/vms/masters/vehicles/uploadfile-response';
@Controller("vehicle")
@ApiTags("/vehicle")
export class VehicleController {
  constructor(
    private service: VehicleService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) {}

  @Post('/fileUpload')
    @ApiConsumes('multipart/form-data')
    @UseInterceptors(FileInterceptor('file', {
        limits: { files: 1 },
        storage: diskStorage({
          destination : join(__dirname, '../../../../',`vrs_vehicle_documents`),

            // destination: './upload_files',
            filename: (req, file, callback) => {
                // console.log(file.originalname);
                const name = file.originalname;
                callback(null, `${name}`);
            },
        }),
        fileFilter: (req, file, callback) => {
          if (!file.originalname.match(/\.(png|jpeg|PNG|jpg|JPG|pjpeg|gif|tiff|x-tiff|x-png)$/)) {
            return callback(new Error('Only png,jpeg,PNG,jpg,gif,tiff,x-tiff,z-png files are allowed!'), false);
          }
          callback(null, true);
        },
    }))
    async updatePath(@UploadedFile() file, @Body() uploadData: any): Promise<UploadResponse> {
      // console.log(file,'-------file')
      // console.log(uploadData,"dhdhddddddddddddc")
      try {
        return await this.service.updatePath(file.path,file.filename, uploadData.id)
      } catch (error) {
        return this.applicationExceptionHandler.returnException(UploadResponse, error);
      }
    }

  @Post("/getAllVehicle")
  async getAllVehicle(): Promise<CommonResponseModel> {
    try {
      return await this.service.getAllVehicle();
    } catch (error) {
      // return errorHandler(ProcurmentGroupResponseModel,error);
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/createVehicle")
  @ApiBody({ type: VehicleDto })
  async createVehicle(@Body() req: any): Promise<CommonResponseModel> {
    try {
      // console.log(req, "ppppppppppp");

      return await this.service.createVehicle(req);
    } catch (error) {
      // return errorHandler(ProcurmentGroupResponseModel,error);
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getActiveAllVehicle")
  async getActiveAllVehicle(): Promise<CommonResponseModel> {
    try {
      return await this.service.getActiveAllVehicle();
    } catch (error) {
      // return errorHandler(ProcurmentGroupResponseModel,error);
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/updateVehicle")
  @ApiBody({ type: VehicleDto })
  async updateVehicle(@Body() req: any): Promise<CommonResponseModel> {
    try {
      return await this.service.updateVehicle(req);
    } catch (error) {
      // return errorHandler(ProcurmentGroupResponseModel,error);
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/activateOrDeactivateVehicle")
  @ApiBody({ type: VehicleDto })
  async activateOrDeactivateVehicle(
    @Body() dto: any,
    isUpdate: boolean = false
  ): Promise<CommonResponseModel> {
    try {
      return await this.service.activateOrDeactivateVehicle(dto);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }
  @Post("/getVehicleDashBoard")
  async getVehicleDashBoard(): Promise<CommonResponseModel> {
    try {
      return await this.service.getVehicleDashBoard();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }
  @Post("/getVehicleServiceDashBoard")
  async getVehicleServiceDashBoard(): Promise<CommonResponseModel> {
    try {
      return await this.service.getVehicleServiceDashBoard();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }
  @Post("/getVehicleReminder")
  async getVehicleReminder(): Promise<CommonResponseModel> {
    try {
      return await this.service.getVehicleReminder();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }


  @Post("/getAvailableVehiclesList")
  @ApiBody({type: VehicleTypeReq})
  async getAvailableVehiclesList(@Body() req:any): Promise<CommonResponseModel> {
    try {
      return await this.service.getAvailableVehiclesList(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getVehiclesByType")
  @ApiBody({type: VehicleTypeReq})
  async getVehiclesByType(@Body() req: any): Promise<CommonResponseModel> {
    // console.log(req);
    try {
      return await this.service.getVehiclesByType(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }
  
  @Post("/getVehicle")
  async getVehicle( ): Promise<CommonResponseModel> {
    try {
      return await this.service.getVehicle();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  @Post("/getVehicleByPlant")
  @ApiBody({type: PlantIdReq})
  async getVehicleByPlant(@Body() req:any ): Promise<CommonResponseModel> {
    try {
      return await this.service.getVehicleByPlant(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(
        CommonResponseModel,
        error
      );
    }
  }

  

}

